<template>
  <a-card :bordered='false'>

    <div class='table-page-search-wrapper'>

      <a-form layout='inline' @keyup.enter.native='searchQuery'>
        <a-row :gutter='24'>
          <a-col :span='10'>
            <a-form-item :label="'日期'" :labelCol='{span: 6}' :wrapperCol='{span: 14, offset: 1}'>
              <a-range-picker
                v-model='queryParam.dataDt'
                format='YYYY-MM-DD' />
            </a-form-item>
          </a-col>
          <a-col :span='14'>
            <a-button style='margin-left: 20px' type='primary' @click='lookTodays'>查看当天数据</a-button>
            <a-button style='margin-left: 20px' type='primary' @click='lookThreedays'>查看近3天数据</a-button>
            <a-button style='margin-left: 20px' type='primary' @click='lookSevenDays'>查看近7天数据</a-button>
          </a-col>
        </a-row>
        <a-row :gutter='24'>
          <a-col :md='12' :sm='8'>
            <a-form-item :label="'产品类型'">
              <a-select
                v-model='queryParam.appssidList'
                mode='multiple'
              >
                <a-select-option v-for='item in appList' :key='item.appssid'>
                  {{ item.appName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :md='12' :sm='8'>
            <a-form-item :label="'数据口径'">
              <a-select default-value='' style='width: 190px' v-model='queryParam.dataType'>
                <a-select-option value='1'>
                  注册当天
                </a-select-option>
                <a-select-option value='2'>
                  注册近3天
                </a-select-option>
                <a-select-option value='3'>
                  注册近7天
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>


        </a-row>
        <a-row :gutter='24'>
          <a-col :md='8' :sm='8'>
            <span style='float: left;overflow: hidden;' class='table-page-search-submitButtons'>
              <a-button type='primary' @click='searchQuery' icon='search'>查询</a-button>
                <a-button type='primary' @click='searchReset' icon='reload' style='margin-left: 8px'>{{ $t('reset')
                  }}</a-button>
              <a-button type='primary' @click='downLoadData' icon='download'
                        style='margin-left: 8px'>{{ $t('exportFile') }}</a-button>
               <a-button type='primary' @click="VisualChart('')" icon='bar-chart'
                         style='margin-left: 8px'>查看可视化图表</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
      <a-table
        ref='table'
        size='middle'
        :columns='columns'
        :data-source='dataSource'
        :loading='loading'
        :pagination='ipagination'
        :scroll='{ x: 2300, y: 2000 }'
        bordered
        @change='handleTableChange'
        @expand='extpand'
      >
        <!--   text该行后端传入的值, record该行所有记录的值,改行索引值-->
        <!--    发短信率    -->
        <template slot='installsOptRateValue' slot-scope='text, record'>
          {{ calculateRate(record.optCount, record.installs) }}
        </template>
        <!--    注册率    -->
        <template slot='optRegRateValue' slot-scope='text, record'>
          {{ calculateRate(record.regCount, record.optCount) }}
        </template>
        <!--   基本信息率    基本信息数量 / json数量    -->
        <template slot='regBasicRateValue' slot-scope='text, record'>
          {{ calculateRate(record.basicCount, record.regCount) }}
        </template>
        <!--   联系人率  联系人数量 / 注册数量   -->
        <template slot='workLinkmanRateValue' slot-scope='text, record'>
          {{ calculateRate(record.linkmanCount, record.basicCount) }}
        </template>
        <!-- 身份证照片率 身份证照片/ 银行卡数量 -->
        <template slot='jsonIdimageRateValue' slot-scope='text, record'>
          {{ calculateRate(record.idimageCount, record.linkmanCount) }}
        </template>
        <!-- 人脸照片率     人脸照片数量/ 银行卡数量 -->
        <template slot='idimageFaceRateValue' slot-scope='text, record'>
          {{ calculateRate(record.faceCount, record.idimageCount) }}
        </template>
        <!--   身份证信息率    身份证信息数量 /  银行卡数量      -->
        <template slot='faceidNoRateValue' slot-scope='text, record'>
          {{ calculateRate(record.idnoCount, record.faceCount) }}
        </template>
        <!-- 银行卡信息率  银行卡数量/ 联系人数量  -->
        <template slot='idNoBankcardRateValue' slot-scope='text, record'>
          {{ calculateRate(record.bankcardCount, record.idnoCount) }}
        </template>
        <!-- JSON率     json数量 / 身份信息数量-->
        <template slot='linkedManJsonRateValue' slot-scope='text, record'>
          {{ calculateRate(record.jsonCount, record.bankcardCount) }}
        </template>

        <!--工作信息率    工作信息数量/基本 * 100% -->
<!--        <template slot='basicWorkRateValue' slot-scope='text, record'>-->
<!--          {{ calculateRate(record.workCount, record.basicCount) }}-->
<!--        </template>-->
        <!--授信数量率       授信数量 / 工作信息数量 * 100% -->
<!--        <template slot='creditQuantityRateValue' slot-scope='text, record'>-->
<!--          {{ calculateRate(record.creditGrantedCount, record.workCount) }}-->
<!--        </template>-->
        <!--   申请率      申请数量 /  工作信息数量 * 100%     -->
        <template slot='bankcardApplyRateValue' slot-scope='text, record'>
          {{ calculateRate(record.applyCount, record.jsonCount) }}
        </template>
        <!--   决策数量率      决策数量 / 申请数量 * 100%     -->
        <template slot='decisionsCountRateValue' slot-scope='text, record'>
          {{ calculateRate(record.decisionsCount, record.applyCount) }}
        </template>
        <!--    过件率      过件数量/ 决策数量 * 100% -->
<!--        <template slot='applyAccessRateValue' slot-scope='text, record'>-->
<!--          {{ calculateRate(record.accessCount, record.decisionsCount) }}-->
<!--        </template>-->
        <!--    放款率    放款数量 / 决策数量 * 100%    -->
        <template slot='accessLoanRateValue' slot-scope='text, record'>
          {{ calculateRate(record.loanCount, record.decisionsCount) }}
        </template>
        <!--        注册-授信转化率   授信/注册-->
<!--        <template slot='regBankCardRateValue' slot-scope='text, record'>-->
<!--          {{ calculateRate(record.creditGrantedCount, record.regCount) }}-->
<!--        </template>-->
        <!--     注册-申请转化率 申请/注册     -->
        <template slot='regApplyRateValue' slot-scope='text, record'>
          {{ calculateRate(record.applyCount, record.regCount) }}
        </template>

        <!--    申请-放款转化率 放款/申请    ??? -->
        <template slot='applyLoanRateValue' slot-scope='text, record'>
          {{ calculateRate(record.loanCount, record.applyCount) }}
        </template>
        <!--    注册-放款转化率 放款/注册     -->
        <template slot='regLoanRateValue' slot-scope='text, record'>
          {{ calculateRate(record.loanCount, record.regCount) }}
        </template>
        <a-table
          slot='expandedRowRender'
          slot-scope='text'
          ref='table'
          size='middle'
          :columns='innerColumns'
          :data-source='text.dataDetails'
          :loading='loading'
          :pagination='false'
          bordered>
          <!--   text该行后端传入的值, record该行所有记录的值,改行索引值-->
          <!--    发短信率    -->
          <template slot='installsOptRateValue' slot-scope='text, record'>
            {{ calculateRate(record.optCount, record.installs) }}
          </template>
          <!--    注册率    -->
          <template slot='optRegRateValue' slot-scope='text, record'>
            {{ calculateRate(record.regCount, record.optCount) }}
          </template>
          <!--   基本信息率    基本信息数量 / json数量    -->
          <template slot='regBasicRateValue' slot-scope='text, record'>
            {{ calculateRate(record.basicCount, record.regCount) }}
          </template>
          <!--   联系人率  联系人数量 / 注册数量   -->
          <template slot='workLinkmanRateValue' slot-scope='text, record'>
            {{ calculateRate(record.linkmanCount, record.basicCount) }}
          </template>
          <!-- 身份证照片率 身份证照片/ 银行卡数量 -->
          <template slot='jsonIdimageRateValue' slot-scope='text, record'>
            {{ calculateRate(record.idimageCount, record.linkmanCount) }}
          </template>
          <!-- 人脸照片率     人脸照片数量/ 银行卡数量 -->
          <template slot='idimageFaceRateValue' slot-scope='text, record'>
            {{ calculateRate(record.faceCount, record.idimageCount) }}
          </template>
          <!--   身份证信息率    身份证信息数量 /  银行卡数量      -->
          <template slot='faceidNoRateValue' slot-scope='text, record'>
            {{ calculateRate(record.idnoCount, record.faceCount) }}
          </template>
          <!-- 银行卡信息率  银行卡数量/ 联系人数量  -->
          <template slot='idNoBankcardRateValue' slot-scope='text, record'>
            {{ calculateRate(record.bankcardCount, record.idnoCount) }}
          </template>
          <!-- JSON率     json数量 / 身份信息数量-->
          <template slot='linkedManJsonRateValue' slot-scope='text, record'>
            {{ calculateRate(record.jsonCount, record.bankcardCount) }}
          </template>

          <!--工作信息率    工作信息数量/基本 * 100% -->
<!--          <template slot='basicWorkRateValue' slot-scope='text, record'>-->
<!--            {{ calculateRate(record.workCount, record.basicCount) }}-->
<!--          </template>-->
          <!--授信数量率       授信数量 / 工作信息数量 * 100% -->
<!--          <template slot='creditQuantityRateValue' slot-scope='text, record'>-->
<!--            {{ calculateRate(record.creditGrantedCount, record.workCount) }}-->
<!--          </template>-->
          <!--   申请率      申请数量 / 工作信息数量 * 100%     -->
          <template slot='bankcardApplyRateValue' slot-scope='text, record'>
            {{ calculateRate(record.applyCount, record.jsonCount) }}
          </template>
          <!--   决策数量率      决策数量 / 申请数量 * 100%     -->
          <template slot='decisionsCountRateValue' slot-scope='text, record'>
            {{ calculateRate(record.decisionsCount, record.applyCount) }}
          </template>
          <!--    过件率      过件数量/ 决策数量 * 100% -->
<!--          <template slot='applyAccessRateValue' slot-scope='text, record'>-->
<!--            {{ calculateRate(record.accessCount, record.decisionsCount) }}-->
<!--          </template>-->
          <!--    放款率    放款数量 / 决策数量 * 100%    -->
          <template slot='accessLoanRateValue' slot-scope='text, record'>
            {{ calculateRate(record.loanCount, record.decisionsCount) }}
          </template>
          <!--        注册-授信转化率   授信/注册-->
<!--          <template slot='regBankCardRateValue' slot-scope='text, record'>-->
<!--            {{ calculateRate(record.creditGrantedCount, record.regCount) }}-->
<!--          </template>-->
          <!--     注册-申请转化率 申请/注册     -->
          <template slot='regApplyRateValue' slot-scope='text, record'>
            {{ calculateRate(record.applyCount, record.regCount) }}
          </template>

          <!--    申请-放款转化率 放款/申请    ??? -->
          <template slot='applyLoanRateValue' slot-scope='text, record'>
            {{ calculateRate(record.loanCount, record.applyCount) }}
          </template>
          <!--    注册-放款转化率 放款/注册     -->
          <template slot='regLoanRateValue' slot-scope='text, record'>
            {{ calculateRate(record.loanCount, record.regCount) }}
          </template>
        </a-table>

      </a-table>


    </div>
    <RefundTradeModal ref='modalForm' @ok='modalFormOk'></RefundTradeModal>
    <custConvertListModal ref='custConvertListModal'></custConvertListModal>
  </a-card>
</template>

<script>
import { filterObj } from '@/utils/util'
import { getApplist, getConvertData } from '@/webpublicapi/order'
import Dict from '../modules/Dict'
import { REFUND_TRADE_STATUS } from '@/constants/status'
import RefundTradeModal from './modules/RefundTradeModal'
import moment from 'moment'
import exportFile from '@/webpublicapi/exportFile'
import custConvertListModal from '@/views/webpublic/platformOrder/ChartsModal/custConvertListModal.vue'

export default {
  name: 'AppList',
  components: {
    custConvertListModal,
    RefundTradeModal,
    Dict
  },
  data() {
    return {
      visible: false,
      REFUND_TRADE_STATUS,
      // 分页参数
      ipagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条'
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },

      headers: {
        // authorization: 'authorization-text',
      },

      dataSource: [],
      innerData: [],
      appList: [],
      // 查询条件
      queryParam: {
        dataDt: [moment().add('days', -6), moment().add('days', 0)],
        appssidList: []
      },
      loading: false,
      // 表头
      columns: [
        {
          title: '日期',
          align: 'left',
          dataIndex: 'dataDt'
        },
        {
          title: 'APP',
          align: 'left',
          dataIndex: 'appName'
        },
        {
          title: '盘号',
          align: 'left',
          dataIndex: 'appSsid'
        },
        {
          title: '安装',
          align: 'left',
          dataIndex: 'installs'
        },
        {
          title: '发送注册OTP号码数',
          align: 'left',
          dataIndex: 'optCount'
        },
        {
          title: '注册',
          align: 'left',
          dataIndex: 'regCount'
        },
        {
          title: '基本信息',
          align: 'left',
          dataIndex: 'basicCount'
        },
        {
          title: '联系人',
          align: 'left',
          dataIndex: 'linkmanCount'
        },
        {
          title: '银行卡信息',
          align: 'left',
          dataIndex: 'bankcardCount'
        },

        {
          title: '身份证照片',
          align: 'left',
          dataIndex: 'idimageCount'
        },
        {
          title: '身份证信息',
          align: 'left',
          dataIndex: 'idnoCount'
        },
        {
          title: '人脸照片',
          align: 'left',
          dataIndex: 'faceCount'
        },
        {
          title: '大JSON',
          align: 'left',
          dataIndex: 'jsonCount'
        },
        //
        //
        // {
        //   title: '工作信息',
        //   align: 'left',
        //   dataIndex: 'workCount'
        // },
        // {
        //   title: '授信数量',
        //   align: 'left',
        //   dataIndex: 'creditGrantedCount' //要修改
        // },
        {
          title: '申请',
          align: 'left',
          dataIndex: 'applyCount'
        },
        {
          title: '决策数量',
          align: 'left',
          dataIndex: 'decisionsCount'
        },
        // {
        //   title: '过件',
        //   align: 'left',
        //   dataIndex: 'accessCount'
        // },
        {
          title: '放款',
          align: 'left',
          dataIndex: 'loanCount'
        },

        {
          title: '发短信率',
          align: 'left',
          dataIndex: 'installsOptRate',
          scopedSlots: { customRender: 'installsOptRateValue' }
        },
        {
          title: '注册率',
          align: 'left',
          dataIndex: 'optRegRate',
          scopedSlots: { customRender: 'optRegRateValue' }
        },
        {
          title: '基本信息率',
          align: 'left',
          dataIndex: 'regBasicRate',
          scopedSlots: { customRender: 'regBasicRateValue' }
        },
        {
          title: '联系人率',
          align: 'left',
          dataIndex: 'workLinkmanRate',
          scopedSlots: { customRender: 'workLinkmanRateValue' }
        },
        {
          title: '银行卡信息率',
          align: 'left',
          dataIndex: 'idNoBankcardRate',
          scopedSlots: { customRender: 'idNoBankcardRateValue' }
        },

        {
          title: '身份证照片率',
          align: 'left',
          dataIndex: 'jsonIdimageRate',
          scopedSlots: { customRender: 'jsonIdimageRateValue' }
        },
        {
          title: '身份证信息率',
          align: 'left',
          dataIndex: 'faceidNoRate',
          scopedSlots: { customRender: 'faceidNoRateValue' }
        },
        {
          title: '人脸照片率',
          align: 'left',
          dataIndex: 'idimageFaceRate',
          scopedSlots: { customRender: 'idimageFaceRateValue' }
        },
        {
          title: 'JSON率',
          align: 'left',
          dataIndex: 'linkedManJsonRate',
          scopedSlots: { customRender: 'linkedManJsonRateValue' }
        },

        //
        // {
        //   title: '工作信息率',
        //   align: 'left',
        //   dataIndex: 'basicWorkRate',
        //   scopedSlots: { customRender: 'basicWorkRateValue' }
        // },
        // {
        //   title: '授信数量率',
        //   align: 'left',
        //   dataIndex: 'creditQuantityRate',  //需要修改
        //   scopedSlots: { customRender: 'creditQuantityRateValue' }
        // },
        {
          title: '申请率',
          align: 'left',
          dataIndex: 'bankcardApplyRate',
          scopedSlots: { customRender: 'bankcardApplyRateValue' }
        },
        {
          title: '决策数量率',
          align: 'left',
          dataIndex: 'decisionsCountRate',
          scopedSlots: { customRender: 'decisionsCountRateValue' }
        },
        {
          title: '过件率',
          align: 'left',
          dataIndex: 'applyAccessRate',
          scopedSlots: { customRender: 'applyAccessRateValue' }
        },
        {
          title: '放款率',
          align: 'left',
          dataIndex: 'accessLoanRate',
          scopedSlots: { customRender: 'accessLoanRateValue' }
        },
        // {
        //   title: '注册-授信转化率',
        //   align: 'left',
        //   dataIndex: 'regBankCardRate',
        //   scopedSlots: { customRender: 'regBankCardRateValue' }
        // },
        {
          title: '注册-申请转化率',
          align: 'left',
          dataIndex: 'regApplyRate',
          scopedSlots: { customRender: 'regApplyRateValue' }
        },
        {
          title: '申请-放款转化率',
          align: 'left',
          dataIndex: 'applyLoanRate',
          scopedSlots: { customRender: 'applyLoanRateValue' }
        },
        {
          title: '注册-放款转化率',
          align: 'left',
          dataIndex: 'regLoanRate',
          scopedSlots: { customRender: 'regLoanRateValue' }
        }
      ],
      //展开项
      innerColumns: [
        {
          title: '分类',
          align: 'left',
          dataIndex: 'appVersion'
        },
        {
          title: '安装',
          align: 'left',
          dataIndex: 'installs'
        },
        {
          title: '发送注册OTP号码数', //可能要删除
          align: 'left',
          dataIndex: 'optCount'
        },
        {
          title: '注册',
          align: 'left',
          dataIndex: 'regCount'
        },
        {
          title: '基本信息',
          align: 'left',
          dataIndex: 'basicCount'
        },

        {
          title: '联系人',
          align: 'left',
          dataIndex: 'linkmanCount'
        },
        {
          title: '身份证照片',
          align: 'left',
          dataIndex: 'idimageCount'
        },
        {
          title: '人脸照片',
          align: 'left',
          dataIndex: 'faceCount'
        },
        {
          title: '身份证信息',
          align: 'left',
          dataIndex: 'idnoCount'
        },
        {
          title: '银行卡信息',
          align: 'left',
          dataIndex: 'bankcardCount'
        },
        {
          title: '大JSON',
          align: 'left',
          dataIndex: 'jsonCount'
        },

        // {
        //   title: '工作信息',
        //   align: 'left',
        //   dataIndex: 'workCount'
        // },
        // {
        //   title: '授信数量',
        //   align: 'left',
        //   dataIndex: 'creditGrantedCount'
        // },
        {
          title: '申请',
          align: 'left',
          dataIndex: 'applyCount'
        },
        {
          title: '决策数量',
          align: 'left',
          dataIndex: 'decisionsCount',
        },
        // {
        //   title: '过件',
        //   align: 'left',
        //   dataIndex: 'accessCount'
        // },
        {
          title: '放款',
          align: 'left',
          dataIndex: 'loanCount'
        },
        {
          title: '发短信率',
          align: 'left',
          dataIndex: 'installsOptRate',
          scopedSlots: { customRender: 'installsOptRateValue' }
        },
        {
          title: '注册率',
          align: 'left',
          dataIndex: 'optRegRate',
          scopedSlots: { customRender: 'optRegRateValue' }
        },
        {
          title: '基本信息率',
          align: 'left',
          dataIndex: 'regBasicRate',
          scopedSlots: { customRender: 'regBasicRateValue' }
        },
        {
          title: '联系人率',
          align: 'left',
          dataIndex: 'workLinkmanRate',
          scopedSlots: { customRender: 'workLinkmanRateValue' }
        },
        {
          title: '身份证照片率',
          align: 'left',
          dataIndex: 'jsonIdimageRate',
          scopedSlots: { customRender: 'jsonIdimageRateValue' }
        },
        {
          title: '人脸照片率',
          align: 'left',
          dataIndex: 'idimageFaceRate',
          scopedSlots: { customRender: 'idimageFaceRateValue' }
        },
        {
          title: '身份证信息率',
          align: 'left',
          dataIndex: 'faceidNoRate',
          scopedSlots: { customRender: 'faceidNoRateValue' }
        },
        {
          title: '银行卡信息率',
          align: 'left',
          dataIndex: 'idNoBankcardRate',
          scopedSlots: { customRender: 'idNoBankcardRateValue' }
        },
        {
          title: 'JSON率',
          align: 'left',
          dataIndex: 'linkedManJsonRate',
          scopedSlots: { customRender: 'linkedManJsonRateValue' }
        },
        // {
        //   title: '工作信息率',
        //   align: 'left',
        //   dataIndex: 'basicWorkRate',
        //   scopedSlots: { customRender: 'basicWorkRateValue' }
        // },
        // {
        //   title: '授信数量率',
        //   align: 'left',
        //   dataIndex: 'creditQuantityRate',  //需要修改
        //   scopedSlots: { customRender: 'creditQuantityRateValue' }
        // },
        {
          title: '申请率',
          align: 'left',
          dataIndex: 'bankcardApplyRate',
          scopedSlots: { customRender: 'bankcardApplyRateValue' }
        },
        {
          title: '决策数量率',
          align: 'left',
          dataIndex: 'decisionsCountRate',
          scopedSlots: { customRender: 'decisionsCountRateValue' }
        },
        {
          title: '过件率',
          align: 'left',
          dataIndex: 'applyAccessRate',
          scopedSlots: { customRender: 'applyAccessRateValue' }
        },
        {
          title: '放款率',
          align: 'left',
          dataIndex: 'accessLoanRate',
          scopedSlots: { customRender: 'accessLoanRateValue' }
        },
        // {
        //   title: '注册-授信转化率',
        //   align: 'left',
        //   dataIndex: 'regBankCardRate',
        //   scopedSlots: { customRender: 'regBankCardRateValue' }
        // },
        {
          title: '注册-申请转化率',
          align: 'left',
          dataIndex: 'regApplyRate',
          scopedSlots: { customRender: 'regApplyRateValue' }
        },
        {
          title: '申请-放款转化率',
          align: 'left',
          dataIndex: 'applyLoanRate',
          scopedSlots: { customRender: 'applyLoanRateValue' }
        },
        {
          title: '注册-放款转化率',
          align: 'left',
          dataIndex: 'regLoanRate',
          scopedSlots: { customRender: 'regLoanRateValue' }
        }
      ],

      isorter: {
        column: 'createTime',
        order: 'desc'
      },
      labelCol: {
        xs: { span: 8 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 16 },
        sm: { span: 19 }
      }
    }
  },
  created() {
    this.loadData(1)
    getApplist().then(res => {
      this.appList = res.data || []
    })
  },
  methods: {
    //计算利率的方法
    calculateRate(a, b) {
      if (a === 0 || b === 0) {
        return 0 + '%'
      } else if (b === 0) {
        console.log('除数为0啦救救我！！')
        // return '-'
        return 0 + '%'
      } else {
        return (a / b * 100).toFixed(2) + '%'
      }
    },
    lookSevenDays() {
      console.log('查看七天')
      this.queryParam.dataDt = [moment().add('days', -6), moment().add('days', 0)]
      this.loadData()
    },
    lookTodays() {
      console.log('查看当天')
      this.queryParam.dataDt = [moment().add('days', -0), moment().add('days', 0)]
      this.loadData()
    },
    lookThreedays() {
      console.log('查看三天')
      this.queryParam.dataDt = [moment().add('days', -2), moment().add('days', 0)]
      this.loadData()
    },
    searchReset() {
      var that = this
      that.queryParam.dataDt = [moment().add('days', -15), moment().add('days', -1)]
      that.queryParam.appssidList = []
      that.queryParam.dataType = ''
      that.loadData()
      // that.loadData(this.ipagination.current)
    },
    searchQuery() {
      this.loadData(1)
    },
    loadData(arg) {
      // 加载数据 若传入参数1则加载第一页的内容
      if (arg === 1) {
        this.ipagination.current = 1
      }
      this.loading = true
      var params = this.getQueryParams()// 查询条件
      if (params.appssidList !== undefined) {
        let arr = params.appssidList
        console.log('params.appssidList---->', params.appssidList)
        if (arr.includes('')) {
          delete params.appssidList
        }
      }
      console.log('params--->', params)
      console.log('params.appssidList--->', params.appssidList)
      getConvertData(Object.assign({}, params)).then((res) => {
        if (res.code === 1000) {
          this.ipagination.total = res.data.total
          this.dataSource = res.data.rows
        } else {
          this.ipagination.total = 0
          this.dataSource = []
          this.$message.error(res.msg)
        }
        this.loading = false
      }).catch(e => {
        this.loading = false
        this.$message.error(e.message)
      })
    },
    getQueryParams() {
      const { dataDt } = this.queryParam
      const data = {
        ...this.queryParam,
        startDate: dataDt && this.transformTime(dataDt[0]),
        endDate: dataDt && this.transformTime(dataDt[1])
      }
      delete data.dataDt
      data.pageNum = this.ipagination.current
      data.pageSize = this.ipagination.pageSize
      return filterObj(data)
    },
    transformTime(time) {
      return moment(time).format('YYYY-MM-DD')
    },
    handleTableChange(pagination, filters, sorter) {
      // TODO 筛选
      // if (Object.keys(sorter).length > 0) {
      //   this.isorter.column = sorter.field
      //   this.isorter.order = sorter.order === 'ascend' ? 'asc' : 'desc'
      // }
      this.ipagination = pagination
      this.loadData()
    },
    extpand(expanded, record) {
      // if(expanded){
      //   this.innerData = record.dataDetails;
      //
      //   console.log("------------->" + record);
      // } else {
      //   this.innerData = [];
      //   console.log("-------------> im close");
      // }

    },
    handleAdd() {
      this.$refs.modalForm.add()
      // this.$refs.modalForm.title = '新增'
    },
    // model回调
    modalFormOk() {
      this.loadData()
    },
    handleChangeUpload(info) {
      if (info.file.status !== 'uploading') {
        console.log(info.file, info.fileList)
      }
      if (info.file.status === 'done') {
        this.$message.success(`${info.file.name} file uploaded successfully`)
      } else if (info.file.status === 'error') {
        this.$message.error(`${info.file.name} file upload failed.`)
      }
    },
    getUrl() {
      var params = this.getQueryParams()// 查询条件
      var url = '/api/web/webpublic/statistics/convertDataExcel?startDate=' + params.startDate + '&endDate=' + params.endDate

      if (params.appssidList) {
        url += '&appssidList=' + params.appssidList
      }
      if (params.dataType) {
        url += '&dataType=' + params.dataType
      }
      return url
    },
    downLoadData() {
      const file = {
        fileUrl: this.getUrl(),
        fileName: 'convertDataExcel.xls'
      }
      this.loading = true
      exportFile(file).catch(e => {
        this.$message.error(e.message)
      }).finally(() => {
        this.loading = false
      })
    },
    downLoadData2(arg2) {
      var params = this.getQueryParams(arg2)// 查询条件
      const file = {
        fileUrl: '/api/web/webpublic/statistics/appAllCountExcel2?startDate=' + params.startDate + '&endDate=' + params.endDate + '&appssidList=' + params.appssidList,
        fileName: 'countLoanDataWithDateExcelColor.xls'
      }
      this.loading = true
      exportFile(file).catch(e => {
        this.$message.error(e.message)
      }).finally(() => {
        this.loading = false
      })
    },
    VisualChart() {
      // console.log('查看哪个产品的图表？', this.queryParam)
      const appssidListValue = this.queryParam.appssidList
      // console.log('appssidListValue-->', appssidListValue)
      // console.log('appssidListValue.lenght-->', appssidListValue.length)
      // console.log('appssidListValue[0]-->', appssidListValue[0])
      if (appssidListValue[0] === undefined) {
        this.$message.error('请选择一个产品！')
      } else if (appssidListValue.length > 1 || appssidListValue[0] === '') {
        this.$message.error('无法查看全部，且只可选择一个产品！')
      } else {
        var paramsechartsarr = this.getQueryParams()
        // console.log('调用弹窗时候的参数', paramsechartsarr)
        getConvertData(Object.assign({}, paramsechartsarr)).then((res) => {
          if (res.code === 1000) {
            console.log('res--->', res.data)
            if (res.data.rows.length == 1) {
              // console.log('有数据')
              this.$refs.custConvertListModal.sendRequest(paramsechartsarr) //调用弹窗中请求方法
              this.$refs.custConvertListModal.openModal() //打开弹出
              this.$refs.custConvertListModal.clearEcharts() //清空上次绘制数据
            } else if (res.data.rows.length > 1) {
              this.$message.error('目前只支持查看一天的内容！！！')
            } else {
              this.$message.error('查询到0条数据！！！')
            }
          }
        }).catch(e => {
          this.$message.error(e.message)
        })

      }
    }

  }
}
</script>
<style lang='less' scoped>
@import "~@/assets/less/common.less";
</style>
